import { PaginatedTransactionResponse, TransactionDetailResponse, CreateTransferRequest, CreateTransferV2Request, TransferCreateResponse, UploadUrlRequest, UploadUrlResponse, TransferFlowValidationResult } from './transaction-domain';

export abstract class TransactionRepository {
  abstract getAll(page: number, pageSize: number): Promise<PaginatedTransactionResponse>;
  abstract getById(id: string): Promise<TransactionDetailResponse>;
  abstract create(request: CreateTransferRequest): Promise<TransferCreateResponse>;
  abstract createV2(request: CreateTransferV2Request): Promise<TransferCreateResponse>;
  abstract generateUploadUrl(request: UploadUrlRequest): Promise<UploadUrlResponse>;
  abstract validateTransferFlow(): Promise<TransferFlowValidationResult>;
}
